import React from 'react';
import {
    Navigate,
    Outlet,
    useLocation
} from "react-router-dom";
import { AuthUser } from './user';
import { useUserContext } from './user-context';

const ProtectedRoute: React.FunctionComponent<{
    redirectPath?: string | undefined,
    children?: React.ReactNode | undefined,
    onAuthorisation(user?: AuthUser): boolean
}> = ({ redirectPath, children, onAuthorisation }) => {
    const location = useLocation();
    const { user, isUserLoggedIn } = useUserContext();
    const isLoggedIn = isUserLoggedIn();

    if (isLoggedIn && user) {
        if (onAuthorisation && !onAuthorisation(user)) {
            return <Navigate to={"/not-authorised"} state={{ from: location }} replace />
        }

        return children ? <>{children}</> : <Outlet />
    } else {
        return <Navigate to={redirectPath ?? "/login"} state={{ from: location }} replace />
    }
};

export default ProtectedRoute;

